import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { Config } from 'shared/config/env.config';
import { catchError, takeWhile } from 'rxjs/operators';
import { BaseHttpService } from 'shared/base/_base-http.service';
import { Alert, ProcessResponse, ProcessStatus } from 'shared/alerts/alerts.model';

@Injectable()
export class AlertsService extends BaseHttpService {
  @Output() processingComplete: EventEmitter<any> = new EventEmitter<any>();

  private alerts: Alert[];

  getAlerts(brandId: string|number): Observable<any> {
    return new Observable(observer => {

      this.http.get(`${Config.API}/process/${brandId}`)
        .pipe(catchError(this.handleError.bind(this)))
        .subscribe((res: ProcessResponse) => {
          this.alerts = res.data;
          observer.next(_.cloneDeep(this.alerts));
          observer.complete();
        });
    });
  }

  getStoredAlerts(brandId) {
    return new Observable(observer => {
      if (this.alerts && !_.isString(this.alerts)) { // not error string
        observer.next(this.alerts);
        return observer.complete();
      } else {
        this.http.get(`${Config.API}/process/${brandId}`)
          .pipe(catchError(this.handleError.bind(this)))
          .subscribe((res: ProcessResponse) => {
            this.alerts = res.data;
            observer.next(_.cloneDeep(this.alerts));
            observer.complete();
          });
      }
    });
  }
}
